function areConsecutiveMonths(months: Date[]): boolean {
  return months.every((month, i) => {
    if (i === 0) return true
    const prev = months[i - 1]
    const expectedNext = new Date(prev.getFullYear(), prev.getMonth() + 1, 1)
    return expectedNext.getFullYear() === month.getFullYear() && expectedNext.getMonth() === month.getMonth()
  })
}

function formatConsecutiveRange(first: Date, last: Date): string {
  const firstMonth = first.toLocaleString('en-US', { month: 'short' })
  const lastMonth = last.toLocaleString('en-US', { month: 'short' })
  const firstYear = first.getFullYear()
  const lastYear = last.getFullYear()

  if (firstYear === lastYear) {
    return `${firstMonth} - ${lastMonth} ${firstYear}`
  }
  return `${firstMonth} ${firstYear} - ${lastMonth} ${lastYear}`
}

/**
   * Format a sorted array of month Date objects into a display string.
 *
 * Rules:
 *  - Single month:               "Jun 2026"
 *  - Consecutive, same year:     "Jun - Aug 2026"
 *  - Consecutive, cross year:    "Dec 2026 - Feb 2027"
 *  - Non-consecutive (any year): "Jan, May, Jul"  (no year shown)
 */
export function formatMonthRange(months: Date[]): string {
  const valid = months.filter((m) => m instanceof Date)
  if (valid.length === 0) return ''

  if (valid.length === 1) {
    return valid[0].toLocaleString('en-US', { month: 'short', year: 'numeric' })
  }

  if (!areConsecutiveMonths(valid)) {
    return valid.map((m) => m.toLocaleString('en-US', { month: 'short' })).join(', ')
  }

  return formatConsecutiveRange(valid[0], valid[valid.length - 1])
}

export function buildFlexiDatesString(numberOfNights: number, selectedMonths: Date[], nightsLabel: string): string {
  if (selectedMonths.length === 0 || numberOfNights === 0) return ''
  const sorted = [...selectedMonths].sort((a, b) => a.getTime() - b.getTime())
  return `${numberOfNights} ${nightsLabel}, ${formatMonthRange(sorted)}`
}
